import { http, } from '../../src/utils/http';
import { observable, action, runInAction, computed } from 'mobx';
import { ReqTableData, ParseObj, ReqData, ParseObj2 } from 'src/models';

const defaultSearch: ProTestSearch = {
  startTime: '',
  endTime: '',
  sn: '',
  psn: '',
  imei: '',
  totalResult: '',
  orderNum: '',
  productCode: '',
  customerName: '',
  version: '',
  category: -1,
}

const parseObj: ParseObj = {
  key: 'id',
  parseFunc: res => {
    const { items, pageSize, pageNum, total } = res.data;
    return {
      page: pageNum,
      pageSize,
      total,
      data: items
    }
  }
}

const parseObj2: ParseObj2 = {
  key: 'viewId',
  parseFunc: res => res.data
}

export class ProductTestStore {

  @observable showMoreFilter = false;
  @observable.ref detailData: any[] = [];

  @observable detailLoading = false;
  @observable detailIndex = 0;

  @observable detailCategory = '2';

  proTestTable = new ReqTableData(
    'product-info/check',
    defaultSearch,
    parseObj
  )

  // proTestDetailReq = new ReqData(
  //   'product-info/check/view',
  //   {viewId: ''},
  //   parseObj2
  // )

  @computed
  get curTabData() {
    return this.detailData.filter(x => x.category == this.detailCategory);
  }

  @action
  changeDetailCategory = (category: string) => {
    this.detailCategory = category;
  }

  @action
  changeDetailIndex = (i: number) => {
    this.detailIndex = i;
  }

  @action
  changeShowMoreFilter = (show: boolean) => {
    this.showMoreFilter = show;
  }

  @action
  getDetail = (viewId: string, category: string) => {
    const url = 'product-info/check/view';
    const params = {
      viewId
    }
    this.detailLoading = true;
    return http.post(url, params).then(res => {
      runInAction(() => {
        this.detailLoading = false;
        const data = res.data || [];

        this.detailIndex = data
          .filter(x => x.category == category)
          .findIndex(x => x.viewId === viewId) || 0;

        this.detailData = data;
      });
    }, err => {
      this.detailLoading = false;
    })
  }
}  